module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-02-2a5d3b27905c1a2070af03ff2d75f4f5.svg";